export const CURRENCY_CONVERSION_LABELS = {
  TITLE: 'Item Currency Adjustments',
  BASE_PRICE: 'Base Price:',
  LAST_UPDATED: 'Last updated:',
  REFRESH_ADJUSTED_PRICES: 'Refresh Adjusted Prices',
  SELECT: 'SELECT',
  CURRENCY: 'CURRENCY',
  CONVERSION_RATE: 'CONVERSION RATE',
  ADJUSTED_PRICE: 'ADJUSTED DISPLAYED PRICE',
  EXPECTED_SETTLEMENT_USD: 'EXPECTED SETTLEMENT (USD)',
  BASE: 'BASE CURRENCY',
  TIP: 'Tip: Adjusted prices are automatically rounded to whole numbers. You can manually override any price for cost of living adjustments.',
  RESTRICT_PURCHASE: 'Restrict Ability to Purchase this Experience',
  SAVE_AND_CLOSE: 'SAVE AND CLOSE',
  SELECTED_EMPTY_PRICE_ERROR: '* Enter Adjusted Price',
  BASE_PRICE_USD: 'Base Price: ',
  DOLLAR_SIGN: 'USD',
  TITLE_INFO: "The Adjusted Displayed Price is the amount that will be shown and charged to fans based on their coutry/currency settings. <br> If you want to provide a different price for an item based on a country/currency's cost of living, use this field to make adjustments. All money is settled in US Dollars in your wallet.",
  NOT_FOUND: 'No International Currency Available',
  LOADING: 'Loading International Currencies...'
};
